import React from 'react'
import { List, Header, } from 'semantic-ui-react'
import { FacebookShareButton, FacebookShareCount, FacebookIcon, TwitterShareButton, TwitterIcon, WhatsappShareButton, WhatsappIcon } from "react-share"

const shareUrl = 'https://rebrand.ly/code_dialer_v1-0-0';
const shareUrlsecond = 'https://rebrand.ly/code_dialer_v1-0-1';

const title = 'Download Code Dialer';

const CodeDialer = () => (

  <List divided relaxed>
    <Header as="h3" textAlign="center">Please select the version you would like to download</Header>
    <List.Item>
            <List.Content>
                

        <List.Header >Mediafire link</List.Header>

        <List.Header href="https://rebrand.ly/code_dialer_v6-1-0" target="_blank" as='a'>Code Dialer version 6.1.0(latest, with ZiG converter)</List.Header>
        <List.Description as='a'>Uploaded April 22 2024</List.Description>
        <List.Description as='a'>
          <h4>Share the link: </h4>
          <List divided relaxed horizontal>
            <List.Item>

              <FacebookShareButton
                url={shareUrlsecond}
                quote={title}
                className="Demo__some-network__share-button">
                <FacebookIcon
                  size={32}
                  round />
              </FacebookShareButton>
            </List.Item>

            <List.Item>

              <TwitterShareButton
                url={shareUrlsecond}
                title={title}
                className="Demo__some-network__share-button">
                <TwitterIcon
                  size={32}
                  round />
              </TwitterShareButton>

            </List.Item>

            <List.Item>
              <WhatsappShareButton
                url={shareUrlsecond}
                title={title}
                separator=":: "
                className="Demo__some-network__share-button">
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>
            </List.Item>
          </List>
        </List.Description>        


        
        <List.Header >Mediafire link</List.Header>

        <List.Header href="https://rebrand.ly/code_dialer_v6-0-0" target="_blank" as='a'>Code Dialer version 6.0.0</List.Header>
        <List.Description as='a'>Uploaded April 2024</List.Description>
        <List.Description as='a'>
          <h4>Share the link: </h4>
          <List divided relaxed horizontal>
            <List.Item>

              <FacebookShareButton
                url={shareUrlsecond}
                quote={title}
                className="Demo__some-network__share-button">
                <FacebookIcon
                  size={32}
                  round />
              </FacebookShareButton>
            </List.Item>

            <List.Item>

              <TwitterShareButton
                url={shareUrlsecond}
                title={title}
                className="Demo__some-network__share-button">
                <TwitterIcon
                  size={32}
                  round />
              </TwitterShareButton>

            </List.Item>

            <List.Item>
              <WhatsappShareButton
                url={shareUrlsecond}
                title={title}
                separator=":: "
                className="Demo__some-network__share-button">
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>
            </List.Item>
          </List>
        </List.Description>
          
        <List.Header >Mediafire link</List.Header>

        <List.Header href="https://rebrand.ly/code_dialer_v5-0-1" target="_blank" as='a'>Code Dialer version 5.0.1</List.Header>
        <List.Description as='a'>Uploaded February 2022</List.Description>
        <List.Description as='a'>
          <h4>Share the link: </h4>
          <List divided relaxed horizontal>
            <List.Item>

              <FacebookShareButton
                url={shareUrlsecond}
                quote={title}
                className="Demo__some-network__share-button">
                <FacebookIcon
                  size={32}
                  round />
              </FacebookShareButton>
            </List.Item>

            <List.Item>

              <TwitterShareButton
                url={shareUrlsecond}
                title={title}
                className="Demo__some-network__share-button">
                <TwitterIcon
                  size={32}
                  round />
              </TwitterShareButton>

            </List.Item>

            <List.Item>
              <WhatsappShareButton
                url={shareUrlsecond}
                title={title}
                separator=":: "
                className="Demo__some-network__share-button">
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>
            </List.Item>
          </List>
        </List.Description>

        <List.Header >Mediafire link</List.Header>

        <List.Header href="https://rebrand.ly/code_dialer_v3-2-2" target="_blank" as='a'>Code Dialer version 3.2.2</List.Header>
        <List.Description as='a'>Uploaded on 19 December 2021</List.Description>
        <List.Description as='a'>
          <h4>Share the link: </h4>
          <List divided relaxed horizontal>
            <List.Item>

              <FacebookShareButton
                url={shareUrlsecond}
                quote={title}
                className="Demo__some-network__share-button">
                <FacebookIcon
                  size={32}
                  round />
              </FacebookShareButton>
            </List.Item>

            <List.Item>

              <TwitterShareButton
                url={shareUrlsecond}
                title={title}
                className="Demo__some-network__share-button">
                <TwitterIcon
                  size={32}
                  round />
              </TwitterShareButton>

            </List.Item>

            <List.Item>
              <WhatsappShareButton
                url={shareUrlsecond}
                title={title}
                separator=":: "
                className="Demo__some-network__share-button">
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>
            </List.Item>
          </List>
        </List.Description>


        <List.Header >Mediafire link</List.Header>

        <List.Header href="https://rebrand.ly/code_dialer_v1-0-2" target="_blank" as='a'>Code Dialer version 1.0.2</List.Header>
        <List.Description as='a'>Uploaded on 28 November 2019</List.Description>
        <List.Description as='a'>
          <h4>Share the link: </h4>
          <List divided relaxed horizontal>
            <List.Item>

              <FacebookShareButton
                url={shareUrlsecond}
                quote={title}
                className="Demo__some-network__share-button">
                <FacebookIcon
                  size={32}
                  round />
              </FacebookShareButton>
            </List.Item>

            <List.Item>

              <TwitterShareButton
                url={shareUrlsecond}
                title={title}
                className="Demo__some-network__share-button">
                <TwitterIcon
                  size={32}
                  round />
              </TwitterShareButton>

            </List.Item>

            <List.Item>
              <WhatsappShareButton
                url={shareUrlsecond}
                title={title}
                separator=":: "
                className="Demo__some-network__share-button">
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>
            </List.Item>
          </List>
        </List.Description>

        <List.Header >Mediafire link</List.Header>

        <List.Header href="https://rebrand.ly/code_dialer_v1-0-1" target="_blank" as='a'>Code Dialer version 1.0.1</List.Header>
        <List.Description as='a'>Uploaded on 25 November 2019</List.Description>
        <List.Description as='a'>
          <h4>Share the link: </h4>
          <List divided relaxed horizontal>
            <List.Item>

              <FacebookShareButton
                url={shareUrlsecond}
                quote={title}
                className="Demo__some-network__share-button">
                <FacebookIcon
                  size={32}
                  round />
              </FacebookShareButton>
            </List.Item>

            <List.Item>

              <TwitterShareButton
                url={shareUrlsecond}
                title={title}
                className="Demo__some-network__share-button">
                <TwitterIcon
                  size={32}
                  round />
              </TwitterShareButton>

            </List.Item>

            <List.Item>
              <WhatsappShareButton
                url={shareUrlsecond}
                title={title}
                separator=":: "
                className="Demo__some-network__share-button">
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>
            </List.Item>
          </List>
        </List.Description>

        <List.Header >Mediafire link</List.Header>

        <List.Header href="https://rebrand.ly/code_dialer_v1-0-0" target="_blank" as='a'>Code Dialer version 1.0.0</List.Header>
        <List.Description as='a'>Uploaded on 18 November 2019</List.Description>
        <List.Description as='a'>
          <h4>Share the link: </h4>
          <List divided relaxed horizontal>
            <List.Item>

              <FacebookShareButton
                url={shareUrl}
                quote={title}
                className="Demo__some-network__share-button">
                <FacebookIcon
                  size={32}
                  round />
              </FacebookShareButton>
            </List.Item>

            <List.Item>

              <TwitterShareButton
                url={shareUrl}
                title={title}
                className="Demo__some-network__share-button">
                <TwitterIcon
                  size={32}
                  round />
              </TwitterShareButton>

            </List.Item>

            <List.Item>
              <WhatsappShareButton
                url={shareUrl}
                title={title}
                separator=":: "
                className="Demo__some-network__share-button">
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>
            </List.Item>
          </List>
        </List.Description>

      </List.Content>
    </List.Item>
  </List>
)

export default CodeDialer